export enum BookingStatus {
    incomplete = 'INC',
    depositPaid = 'DEP',
    complete = 'COM',
    cancelled = 'CAN',
}


export function getBookingStatusDisplay(status: BookingStatus): string {
  switch (status) {
    case BookingStatus.incomplete:
      return 'Incomplete';
    case BookingStatus.depositPaid:
      return 'Deposit Paid';
    case BookingStatus.complete:
      return 'Complete';
    case BookingStatus.cancelled:
      return 'Cancelled';
  }
}
